import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const parseWithOffset = (input: string | Dayjs): Dayjs => {
    // If input is already a Dayjs, it carries its own offset — return as-is.
    // The previous implementation called .toISOString() which UTC-normalises
    // (suffix becomes "Z"), then tried to re-extract the offset via slice(-6)
    // and got garbage like "000.0Z". The result was a Dayjs pinned to UTC,
    // shifting display time by the master's timezone offset. Only manifested
    // for masters in non-UTC timezones — UTC masters silently matched.
    if (dayjs.isDayjs(input)) {
        return input;
    }

    // String input: parse in UTC, then attach the offset suffix (e.g.
    // "+02:00") so .format("HH:mm") returns the original local time.
    const offset = input.slice(-6);
    return dayjs.utc(input).utcOffset(offset);
};

export const normalizeToOffset = (
    date: Dayjs | undefined
): Dayjs | undefined => {
    const offset = "+00:00";
    return date
        ? parseWithOffset(date).utcOffset(offset, true).startOf("day")
        : undefined; // Keeps date within correct local offset
};
